export const RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS =
	'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';

export const RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS =
	'SERVICEDESK_QUEUES_PRIORITY_GROUPS';

export const RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';

export const RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE =
	'SERVICEDESK_NAV3_QUEUE_GROUPS_STATE';

export const SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES =
	'SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES';

export const SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION =
	'SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION';

export const SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY =
	'SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY';

export const LOCAL_STORAGE_KEY_NAV_LOCATION = 'queue-groups-nav-state';

export const LOCAL_STORAGE_KEY_CATEGORY = 'queues-category-state';

export const ONE_DAY_IN_MILLIS: number = 60 * 60 * 1000 * 24;

export const ONE_HOUR_IN_MILLIS: number = 60 * 60 * 1000;
